import React from 'react'
import { Link } from 'react-router-dom'

import PlanBadge from 'components/common/PlanBadge'
import Spinner from 'components/common/Spinner'
import Text from 'components/common/Text'
import Icon from 'components/Icon'
import useAuth from 'hooks/use-auth'
import useClientResource from 'hooks/use-client-resource'
import theme from 'theme'
import { Company } from 'types/api/rbac/company'
import { pluralize } from 'utils/strings'

function getWelcomeMessage(
  first_name?: string,
  isFreeEdition?: boolean
): string {
  const name = first_name ? `, ${first_name}` : ''

  return `Welcome ${!isFreeEdition ? 'back' : ''}${name}!`
}

interface ProfileSectionProps {
  company: Company
}

const ProfileSection: React.FC<ProfileSectionProps> = ({ company }) => {
  const { isFreeEdition, session } = useAuth()
  const { first_name } = session

  const { infraIsLoading, alfiIsLoading, activeClients } = useClientResource()

  const isLoading = infraIsLoading || alfiIsLoading

  return (
    <div
      css={{
        display: 'grid',
        alignItems: 'center',
        gap: theme.space[2]
      }}
      data-testid="dashboard-profile-header"
    >
      <div
        css={{
          alignItems: 'center',
          display: 'grid'
        }}
      >
        <div
          css={{
            display: 'grid',
            gridTemplateColumns: 'auto 1fr',
            alignItems: 'center',
            gap: theme.space[3]
          }}
        >
          <PlanBadge company={company} />
          <div data-testid="dashboard-profile-header-clients">
            {isLoading ? (
              <Spinner css={{ margin: 0 }} size="1em" />
            ) : (
              <Text
                as={Link}
                css={{
                  color: theme.colors.steel[1],
                  display: 'inline-grid',
                  fontSize: theme.fontSizes[1],
                  gridTemplateColumns: 'max-content min-content',
                  gap: theme.space[1],
                  alignItems: 'center',

                  '&:hover svg': {
                    transform: `translateX(${theme.space[1]}px)`
                  }
                }}
                to="/clients"
              >
                <span>
                  {activeClients.length} active{' '}
                  {pluralize('Agent', activeClients.length)}
                </span>
                <Icon
                  css={{
                    transition: 'transform 125ms linear'
                  }}
                  icon="chevronRight"
                />
              </Text>
            )}
          </div>
        </div>
      </div>

      <Text
        as="h2"
        color="medium"
        css={{
          visibility: isLoading ? 'hidden' : 'visible'
        }}
        data-testid="dashboard-profile-header-welcome"
      >
        {getWelcomeMessage(first_name, isFreeEdition)}
      </Text>
    </div>
  )
}

export default ProfileSection
